<template>
  <v-select
    label="Tipo de Pago con Cheques"
    v-model="iModel"
    :items="items"
    item-value="Id_TipoPagoCheque"
    item-text="Nombre"
    :rules="rules"
    :readonly="readonly"
    :loading="loading"
  >
    <template v-slot:no-data
      >No hay datos para mostrar</template
    >
    <template v-slot:progress>
      <v-progress-circular color="blue" indeterminate></v-progress-circular>
    </template>
  </v-select>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
export default {
  name: "SelectTipoPagoCheque",
  props: {
    model: String,
    rules: {},
    readonly: Boolean
  },
  data() {
    return {
      items: [],
      loading: false
    };
  },
  computed: {
    iModel: {
      get() {
        return this.model;
      },
      set(valor) {
        var ind = this.items.findIndex(x => x.Id_TipoPagoCheque == valor);
        this.$emit("seleccionarItem", this.items[ind]);
      }
    }
  },
  created() {
    this.listarItems();
  },
  methods: {
    listarItems() {
      this.loading = true;
      HttpHelper.get("TipoPagoCheque", {
        palabra: ""
      })
        .then(response => {
          this.items = response.data;
          this.loading = false;
        })
        .catch(error => {
          return Promise.reject(error);
        });
    }
  }
};
</script>
